import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { config } from '../../logged/abq-common/config';
import { Subscription } from 'rxjs';
import { SpinnerModalService } from './spinner-modal.service';

@Component({
    selector: 'abq-spinner-modal',
    templateUrl: './spinner-modal.component.html',
    styleUrls: ['./spinner-modal.component.scss']
})
export class SpinnerModalComponent implements AfterViewInit, OnDestroy {

    @Input() public serviceMode = false;
    @ViewChild('spinnerModal') spinnerModalRef: ElementRef;
    private spinnerModal$: JQuery<ElementRef>;
    private subscription: Subscription;
    message: string = '';

    constructor(private spinnerModalService: SpinnerModalService) {
    }

    ngAfterViewInit(): void {
        this.spinnerModal$ = $(this.spinnerModalRef.nativeElement);
        if (this.serviceMode) {
            this.subscribeToSpinnerModalService();
        }
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    show(): void {
        this.spinnerModal$.modal('show');
    }

    showWithMessage(message: string): void {
        this.message = message;
        this.spinnerModal$.modal('show');
    }

    hide(): void {
        setTimeout(() => {
            this.message = '';
            this.spinnerModal$.modal('hide');
        }, config.abqCloseModalAnimationTime);
    }

    private subscribeToSpinnerModalService() {
        this.subscription = this.spinnerModalService.onSpinnerRequest$().subscribe({
            next: (visible: boolean) => {
                if (visible) {
                    this.show();
                } else {
                    this.hide();
                }
            }
        });
    }
}
